import { render, staticRenderFns } from "./SliderLegend.vue?vue&type=template&id=2e4ff205&scoped=true&"
import script from "./SliderLegend.vue?vue&type=script&lang=js&"
export * from "./SliderLegend.vue?vue&type=script&lang=js&"
import style0 from "./SliderLegend.vue?vue&type=style&index=0&id=2e4ff205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ff205",
  null
  
)

export default component.exports